import styled from 'styled-components'

export const FindPatientContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  button {
    margin-top: 10px;
  }
`